<template>
    <div class="footter">
        <div class="title">
            <img src="../assets/logo-footer.webp" alt="logo" />
        </div>
        <div class="footer-content">
            <div class="item">
                <div class="text">Pico Finance：1160/2568</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon1.webp" alt="" class="icon">
                <div class="text">2/116 ถนนเพชรเกษม ตำบลหัวหิน อำเภอหัวหิน จ.ประจวบคีรีขันธ์ 77110</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon2.webp" alt="" class="icon">
                <div class="text">team@poolsukplus.com</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon3.webp" alt="" class="icon">
                <div class="text">0775567004048</div>
            </div>
        </div>
        <div class="c">
            © 2026 สงวนลิขสิทธิ์ POOLSUK PLUS COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
</script>
<style lang="less" scoped>
.footter {
    width: 100%;
    height: 273px;
    background: #370C45;
    padding: 26px 230px 0;
    box-sizing: border-box;

    .title {
        width: 225px;
        height: 41px;
        margin: 0 auto 46px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .footer-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 59px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.31);
        margin-bottom: 9px;

        .item {
            display: flex;
            align-items: center;
            margin-bottom: 26px;

            .icon {
                width: 27px;
                height: 27px;
                object-fit: contain;
                margin-right: 11px;
            }

            .text {
                max-width: 246px;
                font-weight: bold;
                font-size: 12px;
                color: #DCDCDC;
                line-height: 18px;
            }
        }
    }

    .c {
        font-weight: 500;
        font-size: 12px;
        color: #EAEAEA;
        line-height: 24px;
        text-align: center;
    }
}
</style>